<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-sm-3">
          <div class="col-sm-8 float-left">
            <div class="d-flex h-100">
              <div class="align-self-center mx-auto">
                <div class="lead p-buyers">Buyers</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="col-sm-3 float-right">
            <div class="d-flex h-100">
              <div class="align-self-center mx-auto">
                <div class="lead p-search">Search</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-8 float-left">
              <p class="lead p-property_name">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-time">5 mins Ago</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="col-md-6 float-left">
              <p class="lead p-status">Property Name</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-md-8 float-right">
              <p class="lead p-price">$50,000</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style>
body {
  padding-top: 3.75rem;
}

.list-group {
  height: 40vh;
  overflow-y: scroll;
}
.list-group-item {
  padding: 40px !important;
}
.p-property_name {
  font-size: 20px !important;
}
.p-search {
  font-size: 20px !important;
}
.p-time {
  font-size: 10px !important;
}
.p-status {
  font-size: 10px !important;
}
.p-price {
  font-size: 18px !important;
}
</style>